import { getBaseUrl, sendRequest } from "../helpers/apiHelper";

export const getDestinationResolvers = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DestinationResolver`, 'get', null, null, abortSignal);
};
